import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

import { environment } from "../../environments/environment";

export async function getAppVersion(): Promise<string> {
  if (!Capacitor.isNativePlatform()) {
    return "web";
  }
  const { version, build } = await App.getInfo();
  return `${version}-${build}${environment.production ? "" : "-s"}`;
}
